"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSomeDelivarable = void 0;
const luxon_1 = require("luxon");
const Deliverable_1 = require("../entity/Deliverable");
const creative_1 = require("./creative");
const createSomeDelivarable = ({ id = '123', creative = creative_1.createSomeCreative(), attachedThumbnail = creative_1.createSomeCreative(), intent = 'Manners... maketh... man.', state = Object.keys(Deliverable_1.DeliverableState)[1], uploadedAdPlatformKeys = [], createdAt = luxon_1.DateTime.fromMillis(1516701938909, { zone: 'utc' }), stateUpdatedAt = luxon_1.DateTime.fromMillis(1516801938909, { zone: 'utc' }), } = {}) => new Deliverable_1.default({
    id,
    creative,
    attachedThumbnail,
    intent,
    state,
    uploadedAdPlatformKeys,
    createdAt,
    stateUpdatedAt,
});
exports.createSomeDelivarable = createSomeDelivarable;
